import {
  ListOrderRequest,
  MEDIA_HM_PATH,
  Order,
  TicketObjectType,
} from "@project/shared-types";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import { ListOrderAPI } from "../api/payments/CreateOrderAPI";
import { Button } from "../components/button/button";
import { Text } from "../components/texts/text";
import { useUser } from "../context/user/useUser";
import { _size, _sizeText, _style } from "../core/core";
import { useData } from "../hooks/DataContext";
import "./SupportMain.css";
import { useSupport } from "./SupportProvider";
import { SupportTicket } from "./SupportTicket";
import { SupportTitle } from "./SupportTitle";

type SupportState = "NO_AUTH" | "NO_SELECT_ORDER" | "READY";

export const SupportMain = () => {
  const user = useUser();
  const { selectedJobId, selectedOrderId, selectOrder } = useSupport();
  const state = useMemo(() => {
    if (!user) return "NO_AUTH";
    if (!selectedOrderId) return "NO_SELECT_ORDER";
    return "READY";
  }, [user, selectedOrderId]);
  const [orders, setOrders] = useState<Order[]>([]);
  const { products } = useData();

  const navigate = useNavigate();

  const fetchOrders = async () => {
    try {
      var data_req = {
        is_actual: undefined,
      } as ListOrderRequest;
      const response = await ListOrderAPI(data_req); // Замените '/api/service-previews' на ваше API-оконечное точка для получения карточек услуг

      if (response.orders) {
        setOrders(response.orders);
      }
    } catch (e) {
      console.error("Ошибка при получении карточек услуг:", e);
    }
  };
  useEffect(() => {
    if (user) {
      fetchOrders();
    }
  }, [user]);

  const handleLogin = () => {
    navigate("/account/login/");
  };

  const handleSelectOrder = (orderId: string) => {
    selectOrder(orderId);
  };

  if (state === "NO_AUTH") {
    return (
      <div className="support-main">
        <Text size={_sizeText.m}>
          Для начала работы необходимо авторизоваться
        </Text>
        <Button onClick={handleLogin} size={_size.M} style={_style.primary}>
          Войти
        </Button>
      </div>
    );
  }

  if (state === "NO_SELECT_ORDER") {
    return (
      <div className="support-main">
        <SupportTitle></SupportTitle>
        <Text size={_sizeText.m}>
          Выберите заказ для обращения в поддержку:
        </Text>
        <div className="support-orders">
          {orders.map((order) => (
            <Button
              key={order.id}
              onClick={() => handleSelectOrder(order.id)}
              size={_size.M}
              width={"100%"}
              style={_style.outline}
            >
              <div className="support-order-item">
                {products.find(
                  (product) => product.place.id === order.place_id
                ) && (
                  <img
                    src={`${MEDIA_HM_PATH}${
                      products.find(
                        (product) => product.place.id === order.place_id
                      )?.icon
                    }`}
                  ></img>
                )}
                Заказ №{order.number}
              </div>
            </Button>
          ))}
        </div>
      </div>
    );
  }
  const getObjectType = () => {
    if (selectedJobId) return TicketObjectType.JOB;
    return TicketObjectType.ORDER;
  };

  return (
    <SupportTicket
      on_click_back={() => {}}
      on_click_close={() => {}}
      object_type={getObjectType()}
      object_id={selectedOrderId ?? ""}
      user_id={user?.id ?? ""}
      view_id={
        orders
          .find((order) => order.id === selectedOrderId)
          ?.number.toString() ?? ""
      }
    ></SupportTicket>
  );
};
